import $ from 'jquery';
import {showFormResponse} from '../common/json-response';
import {setNotChangedForm} from './save-work-between-step'
import {openQuizTab} from './work-quiz'
import {setSaveButtonActive, setSaveButtonDisabled} from './work-save-button-toggle'
import {
  shouldRunAiTextVerificationOnSave,
  showAiTextVerificationLoading,
  hideAiTextVerificationLoading,
  handleAiTextVerificationResponse,
  AI_TEXT_FIELD_TYPE,
} from './ai-text-work-field';
import {confirmAiImageSelectionsBeforeSave} from './ai-image-field';

// убираем предыдущие сообщения
const formStatusMessages = document.querySelector('.action-status-messages');
const fieldsStatusMessages = document.querySelectorAll('.field-action-status-messages');

// типы настраиваемых полей
const customNumberFieldType   = '1';
const customTextFieldType     = '2';
const customAiTextFieldType   = '13';
const customAttachFieldType   = '3';
const customPhoneFieldType    = '4';
const customCheckboxFieldType = '5';
const customSelectFieldType   = '6';
const customRegionFieldType   = '8';
const customRadioFieldType    = '9';
const customRangeNumberFieldType = '10';
const customTableFieldType       = '11';
const customAiImageFieldType     = '12';

// форматы файлов настраиваемого поля типа Вложение
const attachImageType    = '1';
const attachVideoType    = '2';
const attachAudioType    = '3';
const attachDocumentType = '4';

// Типо столбцов для настраиваемого поля типа Таблица
const columnNumberType   = '1';
const columnTextType     = '2';
const columnSelectType   = '3';
const columnCheckboxType = '4';

let saveBtn;

let fieldsData = {custom_fields: {}};
let isQuiz, limitQuizByTime, activeIndex, activeTabStepUuid, maxIndex, isLastStep, quizTabs;

function getSelectedNomination() {
  let nomination = document.querySelector('[name="category"]:checked');

  if (!nomination) {
    const parentNomination = document.querySelector('[name="category_parent"]:checked');

    if (parentNomination) {
      nomination = parentNomination.closest('.base-nomination')?.querySelector('[name="category"]:checked');
    }
  }

  return nomination;
}

function getStandardWorkFieldsValues(fieldsData) {
  // для обработки ссылок и последующей отправки в других полях "links_old", "links_new"
  const links = [];

  // поля с фиксированными форматами работ для бесплатных конкурсов
  const images = document.querySelectorAll('input[name="images[]"]');
  images?.forEach((item) => {
    fieldsData.images.push(item.value);
  });
  const videos = document.querySelectorAll('input[name="videos[]"]');
  videos?.forEach((item) => {
    fieldsData.videos.push(item.value);
  });
  const audios = document.querySelectorAll('input[name="audios[]"]');
  audios?.forEach((item) => {
    fieldsData.audios.push(item.value);
  });
  const documents = document.querySelectorAll('input[name="documents[]"]');
  documents?.forEach((item) => {
    fieldsData.documents.push(item.value);
  });
  const documentsNotPublic = document.querySelectorAll('input[name="documents_not_public[]"]');
  documentsNotPublic?.forEach((item) => {
    fieldsData.documents_not_public.push(item.value);
  });

  const linksList = document.querySelector('#work-links');
  const linksDataInputs = linksList?.querySelectorAll('input.link_data');
  linksDataInputs?.forEach((item) => {
    const id = item.getAttribute('data-link-id');
    const param = item.getAttribute('data-link-param');
    const isNew = item.getAttribute('data-link-is-new');

    const link = {
      id,
      param,
      isNew,
      value: item.value
    };

    links.push(link);
  });

  links.forEach((link) => {
    if (link.isNew) {
      if (!Object.prototype.hasOwnProperty.call(fieldsData.links_new, link.id)) {
        fieldsData.links_new[link.id] = {};
        fieldsData.links_new[link.id]['id'] = link.id;
        fieldsData.links_new[link.id]['isNew'] = link.isNew;
      }

      fieldsData.links_new[link.id][link.param] = link.value;
    } else {
      if (!Object.prototype.hasOwnProperty.call(fieldsData.links_old, link.id)) {
        fieldsData.links_old[link.id] = {};
        fieldsData.links_old[link.id]['id'] = link.id;
        fieldsData.links_old[link.id]['isNew'] = link.isNew;
      }

      fieldsData.links_old[link.id][link.param] = link.value;
    }
  });

  const workContent = document.querySelector('[name="content"]');
  fieldsData.content = workContent?.value;

  const workContentNotPublic = document.querySelector('[name="content_not_public"]');
  fieldsData.content_not_public = workContentNotPublic?.value;

  return fieldsData;
}

function getWorkContentFields() {
  // убираем предыдущие сообщения
  if (formStatusMessages) {
    formStatusMessages.innerHTML = '';
  }
  fieldsStatusMessages.forEach((field) => {
    field.innerHTML = '';
  });

  const workTitle  = document.querySelector('[name="work_title"]');
  const nomination = getSelectedNomination();

  fieldsData = {
    ...fieldsData,
    work_title: workTitle?.value,
    // Номинации в конкурсе раньше назывались категории.
    // Сейчас категории используются для разделения конкурсов по категориям, а не работ
    // внутри конкурса.
    category: nomination?.value,
    // Иначе в payload утекают старые UUID полей из предыдущих сборок.
    // saveNewCustomWorkFields() создаёт дубли строк в БД
    custom_fields: {},
    images:    [],
    videos:    [],
    audios:    [],
    documents: [],
    links_old: {},
    links_new: {},
    content:   null,
    content_not_public: null,
    documents_not_public: [],
  }

  // настраиваемые поля для платных конкурсов
  let customWorkFieldsSelector = '.custom_work_field';
  const customWorkFields = document.querySelectorAll(customWorkFieldsSelector);

  if (customWorkFields.length) {
    fieldsData = getCustomWorkFieldsValuesByType(customWorkFields, fieldsData);
  } else {
    fieldsData = getStandardWorkFieldsValues(fieldsData);
  }

  return fieldsData;
}

function isCustomWorkFieldVisible(field) {
  if (!(field instanceof HTMLElement)) {
    return false;
  }

  if (field.classList.contains('is-hidden-by-nomination')) {
    return field.querySelector('input[type="checkbox"]:checked, input[type="radio"]:checked') !== null;
  }

  if (field.offsetParent === null) {
    return false;
  }

  return window.getComputedStyle(field).display !== 'none';
}

function getCustomWorkFieldsValuesByType(customWorkFields, fieldsData) {
  fieldsData.custom_fields = {};

  customWorkFields.forEach(function (field) {
    if (!isCustomWorkFieldVisible(field)) {
      return;
    }

    const workFieldUuid = field.getAttribute('data-uuid');
    const type = field.getAttribute('data-type');

    const commonSelector = '[name="custom_fields[' + workFieldUuid + ']';
    const customFieldUuidInput = field.querySelector(commonSelector + '[custom_field_uuid]"]');
    const customFieldNameInput = field.querySelector(commonSelector + '[name]"]');

    if (!workFieldUuid || !customFieldUuidInput || !customFieldNameInput) {
      return;
    }

    const customFieldUuid = customFieldUuidInput.value;
    const customFieldName = customFieldNameInput.value;

    fieldsData['custom_fields'][workFieldUuid] = {
      "type": type,
      "name": customFieldName,
      "custom_field_uuid": customFieldUuid,
      "custom_work_field_uuid": workFieldUuid,
    };

    let value;
    let selector;

    switch (type) {
      // числовое, текстовое, телефонное поля
      case customNumberFieldType:
      case customTextFieldType:
      case customAiTextFieldType:
      case customPhoneFieldType:
      case customRangeNumberFieldType:
        value = field.querySelector(commonSelector + '[value]"]');
        fieldsData['custom_fields'][workFieldUuid]['value'] = value ? value.value : '';

        break;
      case customAttachFieldType:
        fieldsData['custom_fields'][workFieldUuid]['files_ids'] = {};

        // получаем Id файлов изображений
        const images = field.querySelectorAll(commonSelector + '[files_ids][' + attachImageType + '][]"]');
        const imagesIds = [];

        images.forEach(input => {
          imagesIds.push(input.value);
        });

        fieldsData['custom_fields'][workFieldUuid]['files_ids'][attachImageType] = imagesIds;

        // получаем Id видео файлов
        const videos = field.querySelectorAll(commonSelector + '[files_ids][' + attachVideoType + '][]"]');
        const videosIds = [];

        videos.forEach(input => {
          videosIds.push(input.value);
        });

        fieldsData['custom_fields'][workFieldUuid]['files_ids'][attachVideoType] = videosIds;

        // получаем Id аудио файлов
        const audios = field.querySelectorAll(commonSelector + '[files_ids][' + attachAudioType + '][]"]');
        const audiosIds = [];

        audios.forEach(input => {
          audiosIds.push(input.value);
        });

        fieldsData['custom_fields'][workFieldUuid]['files_ids'][attachAudioType] = audiosIds;

        // получаем Id файлов документов
        const documents = field.querySelectorAll(commonSelector + '[files_ids][' + attachDocumentType + '][]"]');
        const documentsIds = [];

        documents.forEach(input => {
          documentsIds.push(input.value);
        });

        fieldsData['custom_fields'][workFieldUuid]['files_ids'][attachDocumentType] = documentsIds;

        break;
      case customAiImageFieldType:
        fieldsData['custom_fields'][workFieldUuid]['files_ids'] = {};

        const aiImages = field.querySelectorAll(commonSelector + '[files_ids][' + attachImageType + '][]"]');
        const aiImagesIds = [];

        aiImages.forEach(input => {
          if (input.value) {
            aiImagesIds.push(input.value);
          }
        });

        fieldsData['custom_fields'][workFieldUuid]['files_ids'][attachImageType] = aiImagesIds;

        break;
      case customCheckboxFieldType:
      case customRadioFieldType:
        selector = commonSelector + '[checked_variants][]"]';
        const checkboxes = field.querySelectorAll(selector);
        const checkedVariants = [];

        checkboxes.forEach(checkbox => {
          if (checkbox.checked) {
            checkedVariants.push(checkbox.value);
          }
        });

        fieldsData['custom_fields'][workFieldUuid]['checked_variants'] = checkedVariants;
        fieldsData['custom_fields'][workFieldUuid]['variants_files'] = {};
        addVariantsFilesToSave(field, workFieldUuid);

        break;
      case customSelectFieldType:
        const select = field.querySelector(commonSelector + '[checked_variants][]"]');

        fieldsData['custom_fields'][workFieldUuid]['checked_variants'] = [select ? select.value : ''];
        fieldsData['custom_fields'][workFieldUuid]['variants_files'] = {};
        addVariantsFilesToSave(field, workFieldUuid);

        break;
      case customRegionFieldType:
        const regionSelect = field.querySelector(commonSelector + '[checked_variants][]"]');

        fieldsData['custom_fields'][workFieldUuid]['checked_variants'] = [regionSelect ? regionSelect.value : ''];

        break;
      case customTableFieldType:
        fieldsData['custom_fields'][workFieldUuid]['columns'] = [];
        const workColumns = field.querySelectorAll('.work-column-value');

        workColumns?.forEach(function (workColumn) {
          const columnUuid = workColumn.getAttribute('data-column-uuid');
          const workColumnUuid = workColumn.getAttribute('data-work-column-uuid');
          const columnType = workColumn.getAttribute('data-column-type');

          switch (columnType) {
            case columnNumberType:
            case columnTextType:
              fieldsData['custom_fields'][workFieldUuid]['columns'].push({
                value: workColumn.value,
                column_type: columnType,
                column_uuid: columnUuid,
                work_column_uuid: workColumnUuid
              });

              break;
            case columnCheckboxType:
              if (workColumn.checked) {
                const variantUuid = workColumn.value;
                let currentColumn = {};
                let currentColumnIndex;
                let variants = [];

                fieldsData['custom_fields'][workFieldUuid]['columns']?.forEach(function (item, index) {
                  if (
                    item.column_uuid === columnUuid &&
                    item.work_column_uuid === workColumnUuid
                  ) {
                    currentColumnIndex = index;
                  }
                });

                if (currentColumnIndex !== undefined && currentColumnIndex !== null) {
                  fieldsData['custom_fields'][workFieldUuid]['columns'][currentColumnIndex]['variants'].push({
                    custom_column_variant_uuid: variantUuid
                  });
                } else {
                  variants.push({
                    custom_column_variant_uuid: variantUuid
                  });
                  fieldsData['custom_fields'][workFieldUuid]['columns'].push({
                    column_type: columnType,
                    column_uuid: columnUuid,
                    work_column_uuid: workColumnUuid,
                    variants
                  });
                }
              }

              break;
            case columnSelectType:
              if (!workColumn.value) {
                break;
              }

              fieldsData['custom_fields'][workFieldUuid]['columns'].push({
                column_type: columnType,
                column_uuid: columnUuid,
                work_column_uuid: workColumnUuid,
                variants: [{
                  custom_column_variant_uuid: workColumn.value
                }]
              });

              break;
          }
        });

        break;
    }
  });

  return fieldsData;
}

function getQuizWorkContentFields() {
  // убираем предыдущие сообщения
  formStatusMessages.innerHTML = '';
  fieldsStatusMessages.forEach((field) => {
    field.innerHTML = '';
  });

  const workTitle  = document.querySelector('[name="work_title"]');
  const nomination = getSelectedNomination();

  fieldsData = {
    ...fieldsData,
    work_title: workTitle?.value,
    // Номинации в конкурсе раньше назывались категории.
    // Сейчас категории используются для разделения конкурсов по категориям, а не работ
    // внутри конкурса.
    category: nomination?.value,
    custom_fields: {},
  }

  // Все настраиваемые поля рендерятся в одной форме сразу (по шагам викторины с data-quiz-uuid).
  // Фильтр только по активной вкладке оставлял в custom_fields "хвосты" через ...fieldsData и давал дубли в БД.
  const customWorkFields = document.querySelectorAll('.custom_work_field');
  fieldsData = getCustomWorkFieldsValuesByType(customWorkFields, fieldsData);

  return fieldsData;
}

function getActiveTabIndex(quizTabs) {
  if (!quizTabs) {
    return 0;
  }

  let activeIndex;

  quizTabs?.forEach(function (item, index) {
    if (item.classList.contains('active')) {
      activeIndex = index;
    }
  });

  return activeIndex;
}

function getActiveTabStepUuid() {
  const activeQuizTab = document.querySelector(".quiz-steps__tab.active");
  const activeQuizTabUuid = activeQuizTab?.getAttribute('data-quiz-tab-uuid');

  return activeQuizTabUuid;
}

function isQuizEnabled(button = saveBtn) {
  return button?.getAttribute('data-is-quiz') === '1';
}

function getSendUrl() {
  let url = saveBtn.getAttribute('data-url');

  if (!isQuizEnabled()) {
    return url;
  }

  if (!quizTabs || !quizTabs.length) {
    return url;
  }

  if (isLastStep) {
    return url;
  }

  return saveBtn.getAttribute('data-draft-url') || url;
}

function initWorkFields() {
  saveBtn = document.querySelector('#saveBtn[name="work-content-save"]');

  if (!saveBtn || saveBtn.dataset.workFieldsSaveBound === '1') {
    return;
  }

  saveBtn.dataset.workFieldsSaveBound = '1';
  saveBtn.type = 'button';

  const workContentForm = saveBtn.closest('form');
  if (workContentForm && workContentForm.dataset.workFieldsSubmitBound !== '1') {
    workContentForm.dataset.workFieldsSubmitBound = '1';
    workContentForm.addEventListener('submit', (event) => {
      event.preventDefault();
    });
  }

  saveBtn.addEventListener('click', async function (e) {
    e.preventDefault();
    setSaveButtonDisabled(saveBtn);

    isQuiz = isQuizEnabled(this) ? '1' : '0';
    limitQuizByTime = this.getAttribute('data-limit-quiz-by-time');
    activeIndex, activeTabStepUuid, maxIndex, isLastStep;
    quizTabs = document.querySelectorAll("#work_quiz_steps_block .quiz-steps__tab");

    if (!isQuizEnabled(this)) {
      fieldsData = getWorkContentFields();
    } else {
      fieldsData = getQuizWorkContentFields();
    }

    if (isQuizEnabled(this) && quizTabs && quizTabs.length) {
      activeIndex = getActiveTabIndex(quizTabs);
      maxIndex = quizTabs.length - 1;
      isLastStep = activeIndex == maxIndex;
      activeTabStepUuid = getActiveTabStepUuid();
      fieldsData['quiz_step_index'] = activeIndex;
      fieldsData['current_quiz_step_uuid'] = isLastStep ? null : activeTabStepUuid;
    }

    const url = getSendUrl();
    const runAiVerification = shouldRunAiTextVerificationOnSave(saveBtn, url);

    try {
      await confirmAiImageSelectionsBeforeSave();
    } catch (error) {
      showFormResponse({
        status: 'error',
        message: error?.message || 'Не удалось сохранить выбранное изображение',
      });
      setSaveButtonActive(saveBtn);
      return;
    }

    if (runAiVerification) {
      showAiTextVerificationLoading();
      if (typeof window.__hideWbStepLoader === 'function') {
        window.__hideWbStepLoader();
      }
    }

    const workContentForm = saveBtn.closest('form');
    if (workContentForm) {
      workContentForm.querySelectorAll('input[type="hidden"]').forEach((element) => {
        if (!element.name || element.disabled) {
          return;
        }

        fieldsData[element.name] = element.value;
      });
    }

    $.ajax({
      type: "POST",
      url: url,
      dataType: 'json',
      data: fieldsData,
      success: function (data) {
        let keepSaveDisabled = false;

        if (runAiVerification) {
          hideAiTextVerificationLoading();
          keepSaveDisabled = handleAiTextVerificationResponse(data, saveBtn);
        }

        showFormResponse(data);

        if (data.status !== 'success') {
          if (typeof window.__hideWbStepLoader === 'function') {
            window.__hideWbStepLoader();
          }
          if (!keepSaveDisabled) {
            setSaveButtonActive(saveBtn);
          }
          return;
        }

        // убираем отметку об изменениях в форме
        // чтобы не было двойного сохранения при закрытии страницы после редиректа
        setNotChangedForm();

        if (data.redirectTo?.length) {
          if (typeof window.__showWbStepLoader === 'function') {
            window.__showWbStepLoader();
          }
          window.location.href = data.redirectTo;
          return;
        }

        if (isQuizEnabled() && quizTabs && quizTabs.length) {
          const nextIndex = activeIndex + 1;
          if (nextIndex <= maxIndex) {
            const nextTab = quizTabs[nextIndex];
            const nextTabUuid = nextTab.getAttribute('data-quiz-tab-uuid');
            openQuizTab(nextTab, nextTabUuid);
          }
        }

        if (!keepSaveDisabled) {
          setSaveButtonActive(saveBtn);
        }
      },
      error: function (data) {
        if (runAiVerification) {
          hideAiTextVerificationLoading();
        }

        showFormResponse(data);
        setSaveButtonActive(saveBtn);
      },
    });
  });
}

function addVariantsFilesToSave(field, workFieldUuid) {
  const checkedVariantsFiles = field.querySelectorAll('.checked-variants-files');

  checkedVariantsFiles?.forEach(variantFile => {
    const variantUuid = variantFile.getAttribute('data-variant-uuid');
    const variantFileType = variantFile.getAttribute('data-variant-type');

    if (!fieldsData['custom_fields'][workFieldUuid]['variants_files'][variantUuid]) {
      fieldsData['custom_fields'][workFieldUuid]['variants_files'][variantUuid] = {'files_ids': {}};
      fieldsData['custom_fields'][workFieldUuid]['variants_files'][variantUuid]['files_ids'][variantFileType] = [];
    }

    fieldsData['custom_fields'][workFieldUuid]['variants_files'][variantUuid]['files_ids'][variantFileType].push(variantFile.value);
  });
}

export { getWorkContentFields, initWorkFields}
